import { Outlet } from 'react-router-dom';
import { Logo } from '@/components';
import { AuthBackdrop } from './auth-backdrop';

/**
 * Casca das telas de entrada: o painel do salao de um lado, o formulario do
 * outro, sobre fundo liso. No celular o painel vira a faixa de cima e o
 * formulario segue embaixo, com a acao no alcance do polegar.
 */
export function AuthLayout() {
  return (
    <div className="flex min-h-dvh flex-col bg-background lg:flex-row">
      <AuthBackdrop />

      <div className="flex flex-1 flex-col px-6 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-4 sm:items-center sm:justify-center sm:py-12 lg:pt-10">
        <div className="flex w-full flex-1 flex-col sm:max-w-[26rem] sm:flex-none">
          <Logo className="mx-auto mb-8 hidden h-12 lg:block" />

          <Outlet />
        </div>
      </div>
    </div>
  );
}
